import { useState } from 'react';
import { useQuery } from '@apollo/client';
import _ from 'lodash';
import { GET_ALL_FEATURE_FLAGS, GET_FEATURE_FLAGS } from './graphql';

const useBaseFeatureFlagsByCompany = (
  companyId,
  mapData,
) => {
  const [featureFlags, setFeatureFlags] = useState({});

  const { loading } = useQuery(GET_FEATURE_FLAGS, {
    variables: { companyId },
    skip: !companyId,
    onCompleted: (data) => {
      setFeatureFlags(mapData(data && data.featureFlagsByCompany));
    },
  });

  return {
    featureFlags,
    loading,
  };
};

const allAttrsDataMapper = (flags) => {
  const transformedObject = flags.reduce((acc, { featureName, ...attrs }) => {
    // use lodash camelcase to transform underscore, space etc into camelCase
    const transformedKey = _.camelCase(featureName);
    acc[transformedKey] = attrs;
    return acc;
  }, {});
  return transformedObject;
};

/**
 * Feature flags with all the attributes
*/
export const useFeatureFlagsWithAttrs = (companyId) => (
  useBaseFeatureFlagsByCompany(companyId, allAttrsDataMapper)
);

export const useAllFeatureFlagsWithAttrs = () => {
  const [featureFlags, setFeatureFlags] = useState({});

  useQuery(GET_ALL_FEATURE_FLAGS, {
    onCompleted: (data) => {
      setFeatureFlags(allAttrsDataMapper(data && data.allFeatureFlags));
    },
  });

  return featureFlags;
};
